<template>
  <div class="info-password-reset-page">
    <img class="layout__q-logo" src="/images/logo-small.svg" />
    <div class="info-password-reset-page__wrapper">
      <!-- Content -->
      <div class="info-password-reset-page__wrapper__content">
        <!-- Logo -->
        <div class="info-password-reset-page__wrapper__content__logo">
          <img
            class="info-password-reset-page__wrapper__content__logo__img"
            :src="`/images/logo.svg`"
            alt="OWQLO"
          />
        </div>

        <!-- Title -->
        <app-i18n 
          class="info-password-reset-page__wrapper__content__title" 
          :code="emailVerification.title" 
        />

        <!-- Description -->
        <div class="info-password-reset-page__wrapper__content__description">
          <div
            class="info-password-reset-page__wrapper__content__description__step"
            v-for="(step, i) in emailVerification.steps" 
            :key="i"
          >
          <app-point-number
            :number="i"
          />
            <app-i18n
              :code="step" 
            />
          </div>
        </div>

         <!-- Phone -->
        <div class="info-password-reset-page__wrapper__content__phone">
          <img class="info-password-reset-page__wrapper__content__phone__img" src="/images/iphone-app-en.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'info-password-reset-page',

  data() {
    return {
      emailVerification: {
        title: 'auth.emailVerification.title',
        steps: {
          1: 'auth.emailVerification.first',
          2: 'auth.emailVerification.second',
          3: 'auth.emailVerification.third'
        }
      }, 
      butttons: {
        android: {
          url: 'https://play.google.com/store/apps/details?id=com.owqlo.app&hl=es_419',
        },
        ios: {
          url: 'https://apps.apple.com/es/app/owqlo/id1441823663',
        },
      },
    };
  },

  computed: {
    currentLanguageCode() {
      return localStorage.getItem('language') || 'en';
    },
    pathIosBadge() {
      if (this.currentLanguageCode === 'en') {
        return 'images/app-store-badge-en.png';
      } else {
        return 'images/app-store-badge-es.png';
      }
    },
    pathAndroidBadge() {
      if (this.currentLanguageCode === 'en') {
        return 'images/google-play-badge-en.png';
      } else {
        return 'images/google-play-badge-es.png';
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.info-password-reset-page .layout__q-logo {
  width: 800px;
}

.info-password-reset-page {
  &__wrapper {
    background-color: white;
    position: absolute;
    width: 800px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
    padding: 7em 4em 7em 4em;

    &__content {
      grid-area: content;
      display: grid;
      grid-template-rows: 100px 80px 120px;
      grid-template-columns: auto auto 200px;
      grid-template-areas: 'logo . phone'
                            'title title phone'
                            'description description phone';

      @include mobile { 
        background-color: white;
        padding: 10%;
        grid-template-rows: 80px 60px 165px;
        grid-template-columns: auto;
        grid-template-areas:  
                              'logo '
                              'title '
                              'description '
                              'phone';
        justify-items: center;
        text-align: center;
      }

      @include small-mobile {
        padding: 8%;
        grid-template-rows: 80px 80px 160px;
      }

      &__logo {
        grid-area: logo;

        &__img {
          width: 240px;

          @include mobile {
            width: 220px;
          }

        }
      }

      &__title {
        grid-area: title;
        font-size: 2rem;
        color: #333333;

        @include mobile {
          font-size: 2rem;
        }
      }
      &__description {
        grid-area: description;
        font-size: 18px;

        &__step {
          display: grid;
          grid-template-areas: 'pos text';
          justify-content: flex-start;
          align-items: flex-start;
          gap: 8px;
          padding-bottom: 16px;

          @include mobile {
            justify-content: center;
          }

          @include small-mobile {
            font-size: 14px;
            gap: 6px;
          }

        }

         @include mobile {
          align-self: center;
        }

      }
      &__phone {
        grid-area: phone;
        justify-self: center;
        align-self: center;

        &__img {
          width: 220px;
          
          @include tablet {
            width: 200px;
          }

          @include mobile {
            width: 180px;
          }
          
        }
      }
    }
    @include tablet {
      width: 650px;
      padding: 5em 3em 5em 3em
    }

    @include mobile {
      align-content: center;
      padding: 0 0 0 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
